import { Modal, Select } from 'antd';
import { AppState } from 'interface/stateApp';
import React, { useEffect, useState } from 'react';
import { useMasterGradesSelector } from '../../../../redux/selector';
import Search from 'antd/es/input/Search';
import { ExerciseFormat } from 'model/response';
import { findAllExerciseFormats } from 'service/exerciseFormatService';

interface ModalProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  subjectId?: string;
  onData?: any;
  key?: any;
}

const { Option } = Select;

const AttachTheoryModal: React.FC<ModalProps> = ({ stateApp, setStateApp, subjectId, key, onData }) => {
  const [selectedExercise, setSelectedExercise] = useState<ExerciseFormat | null>(null);
  const gradeList = useMasterGradesSelector();
  const [classId, setClassID] = useState('');
  const [searchKey, setSearchKey] = useState('');
  const [exercises, setExercises] = useState<ExerciseFormat[]>([]);
  const [exercisesFilter, setExercisesFilter] = useState<ExerciseFormat[]>([]);

  const { showAttachTheoryForm } = stateApp;
  const handleSelect = (value: ExerciseFormat) => {
    setSelectedExercise(value);
  };

  const handleClickSend = () => {
    if (onData) {
      onData(selectedExercise);
    }
    setStateApp({
      ...stateApp,
      showAttachTheoryForm: false,
    });
  };
  const handleFilterByClass = (value: string) => {
    if (value === 'all') {
      setExercisesFilter(exercises);
      setClassID(value);
    } else {
      const filteredExercises = exercises.filter((exercise) => exercise?.grade?.id === value);
      setExercisesFilter(filteredExercises);
      setClassID(value);
    }
  };

  const onSearch = (value: string) => {
    setSearchKey(value);
    if (value === '') {
      setExercisesFilter(exercises);
      setClassID('all');
    } else {
      const filteredExercises = exercises.filter((exercise) =>
        exercise?.name?.toLowerCase().includes(value.toLowerCase()),
      );
      setClassID('all');
      setExercisesFilter(filteredExercises);
    }
  };

  useEffect(() => {
    findAllExerciseFormats(subjectId).then((response) => {
      setExercises(response);
      setExercisesFilter(response);
    });
  }, [subjectId]);

  useEffect(() => {
    setClassID('all');
    setSearchKey('');
  }, [key]);

  return (
    <Modal
      open={showAttachTheoryForm}
      onCancel={() =>
        setStateApp({
          ...stateApp,
          showAttachTheoryForm: false,
        })
      }
      footer={[]}
      className="mx-auto rounded-full login-modal"
    >
      <div className="flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-md w-full mb-3">
          <div className="flex flex-wrap items-center justify-between mb-4">
            <h2 className="text-lg font-bold whitespace-nowrap">Trích dẫn lý thuyết</h2>
            <Search
              placeholder={'Tìm kiếm'}
              rootClassName={'w-[40%] rounded-3xl border border-solid border-primary flex items-center overflow-hidden'}
              onChange={(e) => onSearch(e.target.value)}
              value={searchKey}
            />
          </div>

          <div className="mb-4">
            <Select
              className=" rounded min-w-32"
              defaultValue={'all'}
              onChange={(value) => handleFilterByClass(value)}
              value={classId}
            >
              <Option value="all">Lớp - Tất cả</Option>
              {gradeList.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </div>

          <div className="mb-4">
            <p className="text-gray-600">Dạng bài tập:</p>
            <ul className="mt-2 border rounded-md border-gray-300 p-3 max-h-64 overflow-y-auto">
              {exercisesFilter.map((exercise) => (
                <li key={exercise?.id} className="flex items-center mb-2">
                  <input
                    type="radio"
                    id={`exercise-${exercise?.id}`}
                    name="exercise"
                    value={exercise?.id}
                    checked={selectedExercise?.id === exercise?.id}
                    onChange={() => handleSelect(exercise)}
                    className="mr-2"
                  />
                  <label htmlFor={`exercise-${exercise.id}`} className="text-gray-800">
                    {exercise?.name}
                  </label>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex justify-end space-x-2">
            <button
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
              onClick={() =>
                setStateApp({
                  ...stateApp,
                  showAttachTheoryForm: false,
                })
              }
            >
              Huỷ
            </button>
            <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600" onClick={handleClickSend}>
              Trích dẫn
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AttachTheoryModal;
